$(function() {
  $("html").removeClass('no-js');
  $("html").addClass('js-available');

  var myModal = Frdialogmodal();

});